import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Divider } from "@mui/material";

export default function FormHeader({ title }) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Grid container direction="row">
      <Grid item>
        <Button variant="outlined" onClick={handleGoBack}>
          Atrás
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ fontWeight: "bold", mt: 2 }}>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ mb: 2 }} />
      </Grid>
    </Grid>
  );
}
